import { get, put, post, postJson, del, default as com } from "@/common/api";
import { default as medCom } from "@/common/medApi";

const api = {
  queryReg: com.queryReg,
  queryRp: com.queryRp,
  getSetting: com.getSetting,
  queryRpDetail(para) {
    return get(`/api/op/rpDetail`, para);
  },
  //主数据用户
  queryStaff: (para) => {
    return get("/api/md/staff", para);
  },
  // // 检查治疗申请单信息
  // queryMlApp: (para) => {
  //   return get(`/api/ml/application`, para);
  // },
  // queryMlAppDetail: (para) => {
  //   return get(`/api/ml/applicationDetail`, para);
  // },
  // 查询支付信息(新的收费列表接口)
  queryOpPaymentPageList: (para) => {
    return get("/api/fee/opPayment/pageList", para);
  },
  // 查询门诊支付记录
  queryOpPayment: (para) => {
    return get("/api/fee/opPayment", para);
  },
  getOpPayment: (id) => {
    return get(`/api/fee/opPayment/${id}`);
  },
  // 查询门诊退费记录
  queryOpRefund: (para) => {
    return get("/api/fee/opRefund", para);
  },
  //药品
  rpItem: (para) => {
    return get("/api/op/rpItem", para);
  },
  //草药项目
  rpHerbalItem: (para) => {
    return get("/api/op/rpHerbalItem", para);
  },
  //草药明细
  rpHerbalItemDetail: (para) => {
    return get("/api/op/rpHerbalItemDetail", para);
  },
  //检查
  rpExamineItem: (para) => {
    return get("/api/op/rpExamineItem", para);
  },

  // 处方收费分解
  rpDecompose: (para) => {
    return post("/api/op/charge/rp/decompose", para);
  },

  //处方退费分解
  refundDecompose: (paymentId) => {
    return del(`/api/op/charge/refundDecompose/${paymentId}`);
  },
  // 就诊号收费分解
  regDecompose: (para) => {
    return post("/api/op/charge/reg/decompose", para);
  },
  // refundReg(id) {
  //   return put(`/api/op/reg/${id}/refund`);
  // },
  // 获取支付
  getPayment: com.getPayment,
  // 支付
  payMent: (para) => {
    return post("/api/op/charge/payment", para);
  },

  // 就诊号退费计算
  regPreRefund: (opNo) => {
    return post(`/api/op/charge/reg/${opNo}/refund`);
  },

  // 就诊号退费执行
  regRefund: (opNo) => {
    return del(`/api/op/charge/reg/${opNo}`);
  },

  //处方收费结算
  chargePayment: (para) => {
    return post("/api/op/charge/payment", para);
  },

  //处方退费结算
  refund: (paymentId, invoiceNo) => {
    return del(`/api/op/charge/${paymentId}/confirm/${invoiceNo}`);
  },

  //获取收费员当前发票号
  invoiceCurrent: com.invoiceCurrent,
  // 完成收费员当前发票号
  invoiceNext: () => get("/api/op/regInvoice/next"),

  //加载模版信息
  queryPrintTemplate: (para) => {
    return get("/api/md/printTemplate", para);
  },

  //获取发票数据
  collectInvoiceData: (payId) => {
    return get(`/api/op/charge/invoice/${payId}`);
  },
  // get lodop print template
  getPrintTemplate: com.getPrintTemplate,
  // 查询待收费的单据
  // chgQueryPending: (patientId, opType) => get(`/api/op/fee/chg/${patientId}/receipt/${opType}`),
  chgQueryPending: (patientId) =>
    get(`/api/op/fee/chg/pat/${patientId}/receipt`),
  // 准备收费预分解数据
  chgPrepare: (feeReceipt) => post(`/api/op/fee/chg`, feeReceipt),
  // 清除收费预分解数据
  chgClearPrepare: (patientId) => del(`/api/op/fee/chg/${patientId}`),
  // 执行收费后更新状态
  chgUpdate: (feeReceipt) => put(`/api/op/fee/chg`, feeReceipt),
  // 收费预分解
  chgDivide: (feeDevide) => post(`/api/fee/chg/divide`, feeDevide),
  // 取消收费
  chgCancel: (patientId) => del(`/api/fee/chg/divide/${patientId}`),
  // 执行收费
  chgExec: (paymentId, para) => put(`/api/fee/chg/${paymentId}/exec`, para),
  // 执行收费查询（异步时需要）
  chgExecQuery: (paymentId) => get(`/api/fee/chg/${paymentId}/exec`),
  // 完成收费
  chgFinish: (paymentId) => put(`/api/fee/chg/${paymentId}/finish`),
  // 现金结算
  finishCashPay: (paymentId) => post(`/api/fee/chg/${paymentId}/finishCashPay`),
  // 修改支付方式
  updatePayWay: (para) => post(`/api/fee/chg/updatePayWay`, para),
  // 查询待退费的单据
  rfdQueryPaid: (paymentId) => get(`/api/op/fee/rfd/${paymentId}/receipt`),
  // 准备退费预分解数据
  rfdPrepare: (paymentId, receipt) =>
    post(`/api/op/fee/rfd/${paymentId}`, receipt),
  // 执行退费后更近状态
  rfdUpdate: (feeReceipt) => put(`/api/op/fee/rfd`, feeReceipt),
  // 退费预分解
  rfdDivide: (feeDevide) => post(`/api/fee/rfd/divide`, feeDevide),
  // 取消退费
  rfdCancel: (patientId) => del(`/api/fee/rfd/divide/${patientId}`),
  // 执行退费
  rfdExec: (refundId, para) => put(`/api/fee/rfd/${refundId}/exec`, para),
  // 完成退费
  rfdFinish: (paymentId) => put(`/api/fee/rfd/${paymentId}/finish`),
  // 支付确认修改状态
  chgUpdateState: (para) => put(`/api/fee/chg/payment/state`, para),
  // 校验医保支付时，医保卡持有人与就诊是否一致20230624
  medCardCheckoutUser: (para) => post(`/api/op/med/medCardCheckout`, para),
  // 开票接口
  eBillOutpatient: (data) => post(`/api/fee/ebill/eBillOutpatient`, data),
  // 冲红接口
  writeOffEBill: (data) => post(`/api/fee/ebill/writeOffEBill`, data),
  // 获取公医开票列表
  getEBillPubliclList: (data) =>
    post(`/api/fee/ebill/getEBillPubliclList`, data),
  // 公医开票
  eBillPublic: (data) => post(`/api/fee/ebill/eBillPublic`, data),
  getUsableByPat: com.getUsableByPat,
  getStaff: com.getStaff,
  /**************医保 ************/
  queryMedAnalysis: (medCode, tradeCode, para) =>
    postJson(`/api/op/med/analysis/${medCode}/${tradeCode}`, para), // 明细审核事中分析服务
  queryMedAnalysisFeedback: (medCode, tradeCode, para) =>
    postJson(`/api/op/med/analysis/feedback/${medCode}/${tradeCode}`, para), // 明细审核事中服务反馈服务
  medSellte: medCom.medSellte,
  medDtSellte: medCom.medDtSellte,
  medRefund: medCom.medRefund,
  medDtRefund: medCom.medDtRefund,
  medImpact: medCom.medImpact,
  medCorpuscleRegistered: medCom.medCorpuscleRegistered,
};

export default api;
